<template>
    <XWindow
        ref="window"
        title="Manifest"
        windowClass="height-auto bts-window"
        scrollClass="collection height-auto"
        :width="width"
        :height="height"
        :isMaximized="isMaximized"
        formStatus="view"
        @dialog-state="dialogState"
    >
        <template #left-button>
            <mdb-btn type="button" color="primary" size="sm" :disabled="!canSaveSchedule" @click="saveSchedule">
                <i class="el-icon-check"></i> Save Schedule
            </mdb-btn>
            <mdb-btn type="button" color="elegant" size="sm" :disabled="loading || !header.ManifestNumber" @click="loadManifest">
                <i class="el-icon-refresh"></i> Refresh
            </mdb-btn>
        </template>

        <mdb-tabs class="table-tabs bts-form-tabs mb-0 form mt-1" :active="active" default :links="tabs">
            <template slot="form-slot">
                <mdb-row class="tab-row">
                    <mdb-col col="4" class="tab-col">
                        <ThatsInput
                            :show_error="false"
                            labelClass="col-md-4"
                            fieldClass="col-md-8 pl-0"
                            label="Manifest ID"
                            vid="manifest-view-id"
                            :value="header.ManifestId"
                            :readOnly="true"
                            :rules="''"
                            size="sm"
                        />
                    </mdb-col>
                    <mdb-col col="4" class="tab-col">
                        <ThatsInput
                            :show_error="false"
                            labelClass="col-md-4"
                            fieldClass="col-md-8 pl-0"
                            label="Manifest No."
                            vid="manifest-view-number"
                            :value="header.ManifestNumber"
                            :readOnly="true"
                            :rules="''"
                            size="sm"
                        />
                    </mdb-col>
                </mdb-row>
                <mdb-row class="tab-row">
                    <mdb-col col="4" class="tab-col">
                        <ThatsInput
                            :show_error="false"
                            labelClass="col-md-4"
                            fieldClass="col-md-8 pl-0"
                            label="Ship Name"
                            vid="manifest-view-ship-name"
                            :value="header.ShipName"
                            :readOnly="true"
                            :rules="''"
                            size="sm"
                        />
                    </mdb-col>
                    <mdb-col col="4" class="tab-col">
                        <ThatsInput
                            :show_error="false"
                            labelClass="col-md-4"
                            fieldClass="col-md-8 pl-0"
                            label="Ship Date"
                            vid="manifest-view-ship-date"
                            :value="formattedShipDate"
                            :readOnly="true"
                            :rules="''"
                            size="sm"
                        />
                    </mdb-col>
                    <mdb-col col="4" class="tab-col"></mdb-col>
                </mdb-row>
                <mdb-row class="tab-row">
                    <mdb-col col="4" class="tab-col">
                        <ThatsDatePicker
                            :show_error="false"
                            labelClass="col-md-4"
                            fieldClass="col-md-8 pl-0"
                            label="Scheduled Delivery Date"
                            placeholder="Scheduled Delivery Date"
                            vid="manifest-scheduled-delivery-date"
                            name="scheduledDeliveryDate"
                            v-model="schedule.scheduledDeliveryDate"
                            :disabled="loading || saving"
                            :rules="'required'"
                            size="sm"
                        />
                    </mdb-col>
                    <mdb-col col="4" class="tab-col">
                        <ThatsDatePicker
                            :show_error="false"
                            labelClass="col-md-4"
                            fieldClass="col-md-8 pl-0"
                            label="Scheduled Port Date"
                            placeholder="Scheduled Port Date"
                            vid="manifest-scheduled-port-date"
                            name="scheduledPortDate"
                            v-model="schedule.scheduledPortDate"
                            :disabled="loading || saving"
                            :rules="'required'"
                            size="sm"
                        />
                    </mdb-col>
                    <mdb-col col="4" class="tab-col"></mdb-col>
                </mdb-row>

                <div class="bts-window-form mt-1">
                    <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon class="mb-2" />
                    <div v-loading="loading" ref="spreadsheet" class="manifest-spreadsheet" :style="{ height: spreadsheetHeight }"></div>
                </div>
            </template>
        </mdb-tabs>
    </XWindow>
</template>

<script>
import { mapActions } from 'vuex';
import { mdbBtn, mdbCol, mdbRow, mdbTabs } from 'mdbvue';
import { Message } from 'element-ui';
import XWindow from '../../components/thats/XWindow.vue';
import { ThatsDatePicker, ThatsInput } from '../../components/thats/Thats';
import jspreadsheet from '../../jsexcel/jexcel';
import { formatManifestDate } from './formatters';

const defaultItemPhoto = 'https://media.thatsliving.com/assets/default-item-img-small.jpg';

export default {
    name: 'ManifestForm',
    components: { XWindow, ThatsDatePicker, ThatsInput, mdbBtn, mdbCol, mdbRow, mdbTabs },
    data() {
        return {
            isMaximized: true,
            width: 1100,
            height: 600,
            active: 0,
            tabs: [{ text: 'Details', slot: 'form-slot' }],
            header: {},
            schedule: {
                scheduledDeliveryDate: '',
                scheduledPortDate: ''
            },
            originalSchedule: {
                scheduledDeliveryDate: '',
                scheduledPortDate: ''
            },
            connection: '',
            items: [],
            spreadsheet: null,
            spreadsheetHeight: 'calc(100vh - 235px)',
            spreadsheetOptions: {
                copyCompatibility: true,
                download: false,
                csvFileName: 'manifest',
                editable: false,
                allowCopy: true,
                selectionCopy: true,
                allowDeleteRow: false,
                allowInsertRow: false,
                allowManualInsertRow: false,
                allowInsertColumn: false,
                allowManualInsertColumn: false,
                allowDeleteColumn: false,
                allowRenameColumn: false,
                columnDrag: false,
                rowDrag: false,
                columnSorting: true,
                tableOverflow: true,
                tableWidth: 'calc(100vw - 3px)',
                tableHeight: 'calc(100vh - 235px)',
                freezeColumns: 2,
                minDimensions: [9, 1],
                minSpareCols: 0,
                contextMenu: false,
                data: [],
                updateTable(instance, cell, col, row, val) {
                    if ((row % 2) === 1) cell.parentNode.style.backgroundColor = '#FAFAFA';
                    if (col === 2) {
                        const photo = val || defaultItemPhoto;
                        cell.innerHTML = '<img src="' + photo + '" alt="Item photo" style="width:80px;height:80px;object-fit:contain">';
                        cell.parentNode.style.height = '84px';
                    }
                },
                columns: [
                    { type: 'text', name: 'Container', title: 'Container', width: 180, align: 'left', readOnly: true },
                    { type: 'text', name: 'ItemCode', title: 'Item Code', width: 220, align: 'left', readOnly: true },
                    { type: 'text', name: 'photo', title: 'Photo', width: 90, align: 'center', readOnly: true },
                    { type: 'text', name: 'ItemName', title: 'Item Name', width: 300, align: 'left', readOnly: true },
                    { type: 'numeric', name: 'Quantity', title: 'Qty on Manifest', width: 140, align: 'right', mask: '#,##0.00', decimal: '.', readOnly: true },
                    { type: 'text', name: 'Barcode', title: 'UPC/Barcode', width: 200, align: 'left', readOnly: true },
                    { type: 'text', name: 'BatchNumber', title: 'Batch Number', width: 180, align: 'left', readOnly: true },
                    { type: 'numeric', name: 'UnloadedQty', title: 'Unloaded Qty', width: 140, align: 'right', mask: '#,##0.00', decimal: '.', readOnly: true },
                    { type: 'numeric', name: 'RemainingQty', title: 'Remaining Qty', width: 140, align: 'right', mask: '#,##0.00', decimal: '.', readOnly: true }
                ]
            },
            loading: false,
            saving: false,
            error: '',
            requestId: 0
        };
    },
    computed: {
        formattedShipDate() {
            return formatManifestDate(this.header.ShipDate);
        },
        canSaveSchedule() {
            return !this.loading
                && !this.saving
                && !!this.header.ManifestId
                && !!this.header.ManifestNumber
                && !!this.schedule.scheduledDeliveryDate
                && !!this.schedule.scheduledPortDate
                && (this.schedule.scheduledDeliveryDate !== this.originalSchedule.scheduledDeliveryDate
                    || this.schedule.scheduledPortDate !== this.originalSchedule.scheduledPortDate);
        }
    },
    beforeDestroy() {
        this.resetView();
    },
    methods: {
        ...mapActions('ManifestModule', ['getManifest', 'updateManifestSchedule']),
        openDialog(row, connection) {
            this.resetView();
            this.width = window.innerWidth;
            this.height = window.innerHeight;
            this.header = { ...row };
            this.connection = connection;
            this.setScheduleFromHeader();
            this.$refs.window.openDialog();
            return this.loadManifest();
        },
        closeDialog() {
            this.resetView();
            this.$refs.window.closeDialog();
        },
        dialogState(open) {
            if (!open) this.resetView();
        },
        resetView() {
            this.requestId += 1;
            this.destroySpreadsheet();
            this.header = {};
            this.schedule = { scheduledDeliveryDate: '', scheduledPortDate: '' };
            this.originalSchedule = { scheduledDeliveryDate: '', scheduledPortDate: '' };
            this.connection = '';
            this.items = [];
            this.error = '';
            this.loading = false;
            this.saving = false;
        },
        manifestDateInput(value) {
            if (value === null || value === undefined) return '';
            const match = String(value).trim().match(/^(\d{4}-\d{2}-\d{2})/);
            return match ? match[1] : '';
        },
        setScheduleFromHeader() {
            this.schedule = {
                scheduledDeliveryDate: this.manifestDateInput(this.header.ETAWarehouse),
                scheduledPortDate: this.manifestDateInput(this.header.ETAPort)
            };
            this.originalSchedule = { ...this.schedule };
        },
        async saveSchedule() {
            if (!this.canSaveSchedule) return;
            this.saving = true;
            this.error = '';
            try {
                const response = await this.updateManifestSchedule({
                    manifestId: this.header.ManifestId,
                    manifestNumber: this.header.ManifestNumber,
                    connection: this.connection,
                    scheduledDeliveryDate: this.schedule.scheduledDeliveryDate,
                    scheduledPortDate: this.schedule.scheduledPortDate
                });
                this.header.ETAWarehouse = this.schedule.scheduledDeliveryDate;
                this.header.ETAPort = this.schedule.scheduledPortDate;
                this.originalSchedule = { ...this.schedule };
                Message.success(response && response.message ? response.message : 'Manifest schedule updated.');
                this.$emit('updated');
            } catch (error) {
                const message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Unable to update manifest schedule.';
                this.error = message;
                Message.error(message);
            } finally {
                this.saving = false;
            }
        },
        /* Quantities arrive as strings like "2.000000", and a line with no
           unloading recorded against it has no field at all. */
        manifestQuantity(value) {
            const quantity = Number(value);
            return Number.isFinite(quantity) ? quantity : 0;
        },
        destroySpreadsheet() {
            if (this.spreadsheet) {
                this.spreadsheet.destroy();
                this.spreadsheet = null;
            }
        },
        async renderSpreadsheet(requestId) {
            this.destroySpreadsheet();
            await this.$nextTick();
            if (requestId !== this.requestId || !this.$refs.spreadsheet) return;
            this.spreadsheetOptions.data = this.items.map(item => {
                const manifestQty = this.manifestQuantity(item.Quantity);
                const unloadedQty = this.manifestQuantity(item.UnloadedQty);

                return [
                    item.Container || '',
                    item.ItemCode || '',
                    item.photo || defaultItemPhoto,
                    item.ItemName || '',
                    item.Quantity == null ? '' : item.Quantity,
                    item.Barcode || '',
                    item.BatchNumber || '',
                    unloadedQty,
                    /* What is still on the container: nothing unloaded yet
                       reads as the whole manifest quantity still to come. */
                    manifestQty - unloadedQty
                ];
            });
            this.spreadsheetOptions.minDimensions = [9, Math.max(this.items.length, 1)];
            this.spreadsheet = jspreadsheet(this.$refs.spreadsheet, this.spreadsheetOptions);
        },
        async loadManifest() {
            const requestId = ++this.requestId;
            const manifest = this.header.ManifestNumber;
            this.destroySpreadsheet();
            this.items = [];
            this.error = '';
            if (typeof manifest !== 'string' || !manifest.trim()) {
                this.error = 'This manifest has no document number. Its items cannot be loaded.';
                return;
            }
            this.loading = true;
            try {
                const response = await this.getManifest({ manifest, connection: this.connection });
                if (requestId !== this.requestId) return;
                if (!Array.isArray(response)) throw new Error('Invalid manifest detail response');
                this.items = response;
                await this.renderSpreadsheet(requestId);
            } catch (error) {
                if (requestId !== this.requestId) return;
                this.error = 'Unable to load manifest items. Please try Refresh again.';
            } finally {
                if (requestId === this.requestId) this.loading = false;
            }
        }
    }
};
</script>
